import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import WorkflowSidebar from "../components/WorkflowSidebar";

const ProjectLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen flex flex-col bg-[#f8f9fa] font-['Montserrat']">
      {/* Header */}
      <Header />
      
      {/* Main Content Area with Sidebar - flex container */}
      <div className="flex flex-1 overflow-hidden h-full">
        {/* Desktop Sidebar - hidden on mobile, shown on md+ */}
        <div className="hidden md:block">
          <WorkflowSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
        </div>
        
        {/* Main Content - scrollable */}
        <main className="flex-1 overflow-y-auto overflow-x-hidden">
          {/* Mobile Accordion Sidebar - shown on mobile only */}
          <div className="md:hidden">
            <WorkflowSidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
          </div>
          
          {/* Content wrapper with responsive padding */}
          <div className="px-4 sm:px-6 md:px-8 py-4 sm:py-6 md:py-8">
            {/* This is where child routes will render */}
            <Outlet />
          </div>
        </main>
      </div>
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ProjectLayout;